module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-1022w.514aac8c.jpg";